import React from "react";

const STATS = [
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    value: "30+",
    label: "Years of Enterprise Expertise",
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    value: "200+",
    label: "Global Clients",
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    value: "70+",
    label: "Countries",
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    value: "1992",
    label: "Since",
    reverse: true,
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    value: "ISO 9001",
    label: "Certified",
  },
];

const NewTrustMetrics = () => (
  <section className="trust-v2" aria-label="Company trust metrics">
    <div className="container">
      <div className="trust-v2-stats" role="list">
        {STATS.map(({ icon, value, label, reverse }) => (
          <div key={label} className={`trust-v2-stat${reverse ? " trust-v2-stat--reverse" : ""}`} role="listitem">
            <span className="trust-v2-stat-icon">{icon}</span>
            <div>
              {reverse ? (
                <>
                  <div className="trust-v2-stat-lbl">{label}</div>
                  <div className="trust-v2-stat-val">{value}</div>
                </>
              ) : (
                <>
                  <div className="trust-v2-stat-val">{value}</div>
                  <div className="trust-v2-stat-lbl">{label}</div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="trust-v2-keywords" aria-label="Key positioning statements">
      <span>Delivering cutting-edge software solutions</span>
      <span>Proven execution across industry verticals</span>
      <span>Research-led. Quality-driven. Results-focused.</span>
    </div>
  </section>
);

export default NewTrustMetrics;
